module.exports = __webpack_public_path__ + "static/media/sm_1.5e9b4927.svg";